var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('details',{staticClass:"accordion-item"},[_c('summary',{staticClass:"accordion-item__title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('div',{staticClass:"accordion-item__content"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }